import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Checkbox    from 'app/components/common/checkbox';
import RadioButton from 'app/components/common/radio-button';

class RadioSelect extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onChangeRadio = this.onChangeRadio.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
    this.onClickRadio = this.onClickRadio.bind(this);
  }

  onChangeRadio(event) {
    const value = event.target.value;
    this.props.onSelect(value);
  }

  onChangeCheckbox(event) {
    const value = event.target.value;
    const set = new Set(this.props.value || []);
    const fn = set.has(value) ? 'delete' : 'add';
    set[fn](value);
    this.props.onSelect([...set]);
  }

  onClickRadio(event) {
    if (!this.props.allowClear) return;
    const isSelectedVal = this.props.value === event.target.value;
    if (!isSelectedVal) return;
    this.props.onSelect(null);
  }

  render() {
    const {className, options, value, disabled, isMulti} = this.props;

    return (
      <div className={`radio-select ${className}`}>
        {options.map((opt) => {
          const checked = isMulti
            ? !!((value || []).find(v => v === opt.value))
            : opt.value === value;
          const selectedClass = checked ? 'selected' : '';
          return (
            <label className={`radio-select-opt ${selectedClass}`} key={opt.value}>
              {isMulti ? (<>
                <Checkbox value={opt.value} checked={checked} onChange={this.onChangeCheckbox} disabled={disabled} />
              </>) : (<>
                <RadioButton value={opt.value} checked={checked} onChange={this.onChangeRadio} disabled={disabled} onClick={this.onClickRadio} />
              </>)}
              {opt.label}
            </label>
          );
        })}
      </div>
    );
  }

}

RadioSelect.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any,
    type: PropTypes.oneOf(['hr']),
  })).isRequired,
  value: PropTypes.any,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  allowClear: PropTypes.bool,
  isMulti: PropTypes.bool,
};

RadioSelect.defaultProps = {
  className: '',
  disabled: false,
  allowClear: false,
  isMulti: false,
};

export default RadioSelect;
